export default "__VITE_ASSET__ecc76886__"